import { Injectable } from '@angular/core';
import { ConfigBaseFilter, ConfigService, ListLayout, ListLayoutMultipleComponent, ListSortOption } from 'gung-list';
import { OrderService, SelectedCustomerService, OrderRow, Product, ProductService } from 'gung-standard';
import { Observable, of, forkJoin } from 'rxjs';
import { map, tap, switchMap, mergeMap, first } from 'rxjs';
import { TyloDeliveryPlanningCardListComponent } from '../components/tylo-delivery-planning-card-list/tylo-delivery-planning-card-list.component';
import { TyloOrderRowsService } from './tylo-order-rows.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TyloDeliveryPlanningEditModalComponent } from '../components/tylo-delivery-planning-edit-modal/tylo-delivery-planning-edit-modal.component';

export interface OrderRowsByDate {
  date: string;
  weight: number;
  volume: number;
  totalSales: number;
  currency: string;
  rows: OrderRowExtended[];
  grossWeight: number;
  netWeight: number;
  amount: number;
}

interface OrderRowExtended extends OrderRow {
  product?: Product;
}

@Injectable({
  providedIn: 'root'
})
export class TyloDeliveryPlanningListConfigService implements ConfigService<OrderRow> {
  constructor(
    protected orderService: OrderService,
    protected selectedCustomerService: SelectedCustomerService,
    private productService: ProductService,
    private orderRowsService: TyloOrderRowsService
  ) {}

  getItems(): Observable<OrderRow[]> {
    //const currentDate = new Date();
    return this.selectedCustomerService.getSelectedCustomer().pipe(
      first(),
      mergeMap(customer => this.orderRowsService.getOrderRowsDeliveryPlanning(customer.id))
    );
  }

  getFilters(): ConfigBaseFilter<OrderRow>[] {
    return [];
  }

  getLayouts(): ListLayout<OrderRow>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => TyloDeliveryPlanningCardListComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'Order list'
      }
    ];
  }

  getSortOptions(): ListSortOption<OrderRow>[] {
    // TODO: implement
    return [];
  }

  getBatchSizes(): number[] {
    return [24];
  }

  getSearchTerms(item: OrderRow): string[] {

    return [item.extra.orp.kundbestnr, item.name];
  }

  getItemId(item: OrderRow): string {
    return '';
  }

  getNothingFoundTranslateTag() {
    return 'NOTHING_FOUND';
  }

  getSearchGroupCss() {
    return '';
  }

  isOrderRowOneDayOld(currentDate: Date, orddatum: string) {
    const orderDate = new Date(orddatum);
    orderDate.setDate(orderDate.getDate() + 1);
    return currentDate.getTime() <= orderDate.getTime();
  }
}
